const formData = {
  formId: "jobOrderForm",
  formField: {
    createdDate: {
      name: "createdDate",
      label: "Created Date",
    },
    fillByDate: {
      name: "fillByDate",
      label: "Crew Change Needed",
      requiredErrorMessage: "Date is required.",
    },
    smis: {
      name: "smis",
      label: "SMIS Job #",
    },
    vessel: {
      name: "vessel",
      label: "Vessel",
      requiredErrorMessage: "Vessel is required.",
    },
    assignee: {
      name: "assignee",
      label: "Assignee",
      requiredErrorMessage: "Assignee is required.",
    },
    onsigner: {
      name: "onsigner",
      label: "Onsigner",
      requiredErrorMessage: "Onsigner is required.",
    },
    onsignerLeavingFrom: {
      name: "onsignerLeavingFrom",
      label: "Leaving From",
      requiredErrorMessage: "Onsigner Leaving From is required.",
    },
    onsignerDestination: {
      name: "onsignerDestination",
      label: "Destination",
      requiredErrorMessage: "Onsigner destination is required.",
    },
    onsignerTravelTimestamp: {
      name: "onsignerTravelTimestamp",
      label: "Time",
      requiredErrorMessage: "Onsigner travel time is required.",
    },
    onsignerAccomodation: {
      name: "onsignerAccomodation",
      label: "Hotel or Rental",
      requiredErrorMessage: "Onsigner Accomodation is required.",
    },
    onsignerPickupDate: {
      name: "onsignerPickupDate",
      label: "Check In / Pick Up Date",
      requiredErrorMessage: "Onsigner Check In / Pick Up Date is required.",
    },
    onsignerDropoffDate: {
      name: "onsignerDropoffDate",
      label: "Check Out / Drop Off Date",
      requiredErrorMessage: "Onsigner Check Out / Drop Off Date is required.",
    },
    onsignerNotes: {
      name: "onsignerNotes",
      label: "Onsigner Comments",
    },
    onsignerTwicTsaNum: {
      name: "onsignerTwicTsaNum",
      label: "TWIC or TSA #",
    },
    onsignerDateOfBirth: {
      name: "onsignerDateOfBirth",
      label: "DOB",
    },
    onsignerAgentUnion: {
      name: "onsignerAgentUnion",
      label: "Mariner Union",
    },
    onsignerUnionHall: {
      name: "onsignerUnionHall",
      label: "Union Hall",
    },
    offsigner: {
      name: "offsigner",
      label: "Offsigner",
      requiredErrorMessage: "Offsigner is required.",
    },
    offsignerLeavingFrom: {
      name: "offsignerLeavingFrom",
      label: "Port Relief Requested",
      requiredErrorMessage: "Offsigner Port Relief location is required.",
    },
    offsignerDestination: {
      name: "offsignerDestination",
      label: "Destination or Cash in Lieu",
      requiredErrorMessage: "Destination or Cash in Lieu is required.",
    },
    offsignerTravelTimestamp: {
      name: "offsignerTravelTimestamp",
      label: "Time",
    },
    offsignerAccomodation: {
      name: "offsignerAccomodation",
      label: "Hotel or Rental",
    },
    offsignerPickupDate: {
      name: "offsignerPickupDate",
      label: "Check In / Pick Up Date",
      requiredErrorMessage: "Offsigner pickup date is required.",
    },
    offsignerDropoffDate: {
      name: "offsignerDropoffDate",
      label: "Check Out / Drop Off Date",
      requiredErrorMessage: "Offsigner Dropoff Date is required.",
    },
    offsignerNotes: {
      name: "offsignerNotes",
      label: "Offsigner Comments",
    },
    checklistRoot: {
      name: "checklistRoot",
      label: "",
    },
    travelDocuments: {
      name: "travelDocuments",
      label: "Travel Documents",
    },
    rating: {
      name: "rating",
      label: "Rating",
      requiredErrorMessage: "Rating is required.",
    },
    port: {
      name: "port",
      label: "Port Relief Actual",
      requiredErrorMessage: "Port is required.",
    },
    reliefReason: {
      name: "reliefReason",
      label: "Reason",
      requiredErrorMessage: "Reason is required.",
    },
    flightNotice: {
      name: "flightNotice",
      label: "Fly 24hr Prior (Y/N)",
    },
    reliefTime: {
      name: "reliefTime",
      label: "Estimated Relief Time (hours)",
      requiredErrorMessage: "Relief Time is required.",
    },
    offsignerTwicTsaNum: {
      name: "offsignerTwicTsaNum",
      label: "TWIC or TSA #",
    },
    offsignerDateOfBirth: {
      name: "offsignerDateOfBirth",
      label: "DOB",
    },
    publish: {
      name: "publish",
      label: "Publish to Job Board",
    },
    covid19Testing: {
      name: "covid19Testing",
      label: "COVID-19 Testing",
    },
    testingLocation: {
      name: "testingLocation",
      label: "Testing Location",
    },
    jobType: {
      name: "jobType",
      label: "Job Type",
    },
    note: {
      name: "note",
      label: "Job Order Notes",
    },
    extra: {
      name: "extra",
      label: "Mark As Extra",
    },
  },
};

export default formData;
